import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Btn from '../btns/Btn'
import { useLocation } from 'react-router-dom'

function AboutIntro({classes=""}) {
    const location = useLocation();
  return (
    <>
        <style>{`
            .about-img { padding-top: 24px; padding-left: 24px; position: relative; }
            .about-img::before { content: ''; position: absolute; width: 100%; height: 100%; left: 0; top: 0; background: var(--gradiant); z-index: -1; opacity: .25; clip-path: polygon(96% 0, 100% 3.5%, 100% 100%, 4% 100%, 0 97%, 0 0%); }
            .about-img { position: relative; }
            .about-img img { width: 100%; }
            .about-acheivment { position: absolute; bottom: -30px; max-width: 340px; right: 0; background: var(--gradiant); color: var(--white); padding: 24px 20px; padding-left: 90px; min-height: 100px; font-size: 18px; }
            .about-img-wrapper { position: relative; margin-bottom: 30px; }
            .about-acheivment-icon { display: block; width: 60px; position: absolute; left: 15px; top: 25px; }
            .about-acheivment-icon img { width: 100%; filter: brightness(0) invert(1); }
            .about-acheivment::before { content: ''; border-left: 40px solid transparent; border-top: 30px solid var(--primaryDark); position: absolute; bottom: 0; right: 100%; }
            .about-text-wrapper .heading { margin-bottom: 20px; }
            .about-quote-card { background-color: var(--light); margin-bottom: 20px; padding: 30px; z-index: 9; border-left: 3px solid var(--primary); position: relative; color: #666; }
            .about-quote-text { font-size: 20px; font-style: italic; margin-bottom: 10px; font-weight: 500; }
            .about-quote-by { font-size: 16px; }
            .about-quote-by strong { font-weight: 500; color: #333; }
            .about-quote-icon { position: absolute; color: var(--primary); font-size: 120px; top: 50%; transform: translateY(-50%); right: 40px; opacity: .2; z-index: -1; }
            .about-text-wrapper .about-cta { margin-bottom: 20px; }
            .about-text-wrapper .about-info ul li { padding-left: 30px; position: relative; margin-bottom: 10px; }
            .about-text-wrapper .about-info ul li::before { content: '\\f00c'; font-family: "Font Awesome 6 Free"; font-weight: 900; color: var(--primary); width: 24px; height: 20px; background: transparent; line-height: 20px; text-align: center; vertical-align: bottom; top: 2px; position: absolute; display: block; left: 0; }
            @media screen and (max-width:1199.98px) { }
            @media screen and (max-width:991.98px) {
                .about-acheivment { max-width: 250px; padding: 20px; padding-left: 80px; font-size: 16px; line-height: 22px; }
            }
            @media screen and (max-width:767.98px) {
                .about-img { padding: 12px 0 0 12px; }
                .about-img::before { clip-path: polygon(96% 0, 100% 2.5%, 100% 100%, 3% 100%, 0 97%, 0 0%); }
                .about-img-wrapper { margin-bottom: 50px; }
                .about-acheivment { bottom: -20px; max-width: calc(100% - 76px); }
                .about-acheivment::before { border-left-width: 20px; border-top-width: 20px; }
                .about-quote-text { font-size: 18px; }
                .about-quote-by { font-size: 14px; }
            }
        `}</style>
        <div className={`section-padding about-container ${classes}`} id='down'>
            <Container>
                <Row className='align-items-start align-items-xl-center' data-aos="fade-up">
                    <Col md={6} className=' pe-lg-5  is-sticky-desk'>
                        <div className="about-img-wrapper">
                            <div className="about-img">
                                <img src="../assets/images/about/about.jpg" alt="" />
                            </div>
                            <div className="about-acheivment">
                                <span className="about-acheivment-icon">
                                    <img src="../assets/images/about/acheivment.png" alt="" />
                                </span>
                                9+ Years Experience In this web development and Designing				
                            </div>
                        </div>
                    </Col>
                    <Col md={6}>
                        <div className="about-text-wrapper">
                            <div className="heading">
                                <h6><span>About Company</span></h6>
                                <h3>Your Trusted Partners For <span>Software</span> Innovation</h3>
                            </div>
                            <p>Testing Services, Custom application development, IT consulting services and our best services like Software Development, Web Design, Apps Development, Internet Marketing Services.</p>
                            <div className="about-quote-card">
                                 <span className="about-quote-icon">
                                    <i className="fa-solid fa-quote-left"></i>
                                 </span>
                                 <div className="about-quote-text">
                                     As one of the best IT Service Providers, our deep pool of over 99+ certified engineers and IT support staff
                                 </div>
                                 <div className="about-quote-by">
                                  - Elliot Anderson
                                 </div>
                            </div>
                            <p>It's great to hear about your mission once again! Developing compelling brand identities, crafting immersive  digital experiences, and designing impactful print materials are key components in elevating a company's presence and engagement. Is there anything specific you'd like to discuss or focus on related to these aspects? I'm here to help!</p>
                            {
                                location.pathname !== '/about-us' ?
                                
                            <div className="about-cta mb-3">
                                <Btn route="/about-us/" type="default" value="Get Started" />
                            </div> : null
                            }
                            <div className="about-info">
                                <ul className='mb-0'>
                                    <li>We are committed to providing quality IT Services</li> 
                                    <li>Provided by experts to help challenge critical activities</li>
                                    <li>Really know the true needs and expectations of customers</li>
                                </ul>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </>
  )
}

export default AboutIntro